import { RootState } from "shared/types";
import { PreclassTestNameType } from "shared/types/preclass_check";

export const selectChatTextAreaContent = () => (state: RootState) =>
  state.local.chatTextAreaContent;
export const selectChatTextAreaContentOverride = () => (state: RootState) =>
  state.local.chatTextAreaContentOverride;
export const selectCurrentUserId = () => (state: RootState) => state.local.currentUserId;
export const selectCurrentlyBackingUpPoll = () => (state: RootState) =>
  state.local.currentlyBackingUpPoll;
export const selectHasNewChatMessages = () => (state: RootState) => state.local.hasNewChatMessages;
export const selectHasStageChanged = () => (state: RootState) => state.local.hasStageChanged;
export const selectKeyboardShortcutSignal = () => (state: RootState) =>
  state.local.keyboardShortcutSignal;
export const selectLocalModalContent = () => (state: RootState) => state.local.localModalContent;
export const selectOverlayError = () => (state: RootState) => state.local.overlayError;
export const selectPubsubErrorCode = () => (state: RootState) => state.local.pubsubErrorCode;
export const selectPubsubMessage = () => (state: RootState) => state.local.pubsubMessage;
export const selectShowInstructorNotes = () => (state: RootState) =>
  state.local.showInstructorNotes;
export const selectSidebarPanel = () => (state: RootState) => state.local.sidebarPanel;
export const selectPreclassCheckResults = () => (state: RootState) =>
  state.local.preclassCheckResults;
export const selectPreclassCheckResultByName =
  (testName: PreclassTestNameType) => (state: RootState) =>
    state.local.preclassCheckResults[testName];
export const selectJoinTimestamp = () => (state: RootState) => state.local.joinTimestamp;
